<template>
  <Box>
    <div class="dialog">
      <div class="header has-bcc-background has-text-white">
        <span>Select the institution and report types for the new account</span>
      </div>

      <div class="body">
        {{ newAccountData.firstName }} {{ newAccountData.lastName }} ({{ newAccountData.email }}) <br /><br />
        <EditRoleClient :model="membershipInput" :errors="errors" @membershipUpdated="onMembershipUpdated" />
      </div>

      <div class="actions">
        <button class="button" @click="closeDialog('close')">Cancel</button>
        &nbsp;&nbsp;
        <button
          class="button has-bcc-background has-text-white"
          @click="
            () => {
              if (!membershipInput.institutionIds.length || membershipInput.institutionIds[0] <= 0 || !membershipInput.reportTypeCodes.length) {
                errors.institutionId = 'Please select at least one institution.'
                errors.reportTypeCodes = 'Please select at least one report type.'
                return
              } else {
                errors.institutionId = ''
                errors.reportTypeCodes = ''
              }
              closeDialog(membershipInput)
            }
          "
        >
          Submit
        </button>
      </div>
    </div>
  </Box>
</template>

<script setup>
import { ref, reactive } from 'vue'
import Box from './Box.vue'
import { closeDialog } from 'vue3-promise-dialog'
import axios from '../../axios'
import { useGlobalUtils } from '../../helpers/globalUtils'
import EditRoleClient from '../EditRoleClient.vue'

const { errorToast, successToast } = useGlobalUtils()

function onMembershipUpdated(event) {
  Object.assign(membershipInput, event)
}

const props = defineProps({
  newAccountData: {
    type: Object,
    required: true,
  },
})

const errors = ref({})

const membershipInput = reactive({
  userId: null,
  institutionIds: [],
  reportTypeCodes: [],
})
</script>

<style scoped lang="scss">
@import './dialog.scss';

.dialog {
  width: 800px;
  max-width: 90vw;
  min-width: 300px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.form-row {
  display: flex;
  gap: 10px;

  .field {
    margin-bottom: 0.75rem;

    &.half {
      flex: 1;
    }

    &.two-thirds {
      flex: 2;
    }

    &.one-third {
      flex: 1;
    }
  }
}

.actions {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #ddd;
  padding: 10px;
}
</style>
